const bb = { path: '/compare-tv-broadband-phone/', name: 'Broadband', heading: 'Get the best broadband deals from {bb}*', bodyText: `Find the best deal for you and sign up to your new provider online in minutes.`, ctaText: 'Apply now' };
const money = { path: '/money/', heading: 'Banking', name: 'Banking & Personal Finance', bodyText: 'Find the best banking options for you in minutes', ctaText: 'Compare now' };
const mortgage = { path: '/compare-mortgages/', name: 'Mortgage', heading: 'Arrange your mortgage with bonkers.ie', bodyText: 'Our free mortgage broker service will be there to guide you through your entire mortgage application process', ctaText: 'Apply now' };

export const CATEGORIES = {
  'banking': money,
  'broadband': bb,
  'broadband-phone': bb,
  'broadband-tv': bb,
  'broadband-tv-phone': bb,
  'gas-electricity': { path: '/compare-gas-electricity-prices/', name: 'Gas & Electricity', heading: 'Switch Gas & Electricity with bonkers.ie', bodyText: 'Find the cheapest energy deal and save on average {nrg}*', ctaText: 'Save now' },
  'insurance': { path: '/compare-insurance/', heading: 'Insurance', bodyText: 'Apply online and get cover in under an hour', ctaText: 'Start now' },
  'health-insurance': { path: '/compare-health-insurance/', heading: 'Health Insurance', bodyText: 'Find the lowest rates', ctaText: 'Start now' },
  'mortgage': mortgage,
  'mortgages': mortgage,
  'personal-finance': money
};
